import PropTypes from 'prop-types';

import { CircularProgress } from '@mui/material';

import { LOADING } from '../../utils/formValidation/loadingErrorMessageConstants';

import app from '../../app.module.css';

const BusyIndicator = ({ customClass = '' }) => {
    return (
        <div data-testid="testIdBusyIndicator" className={customClass}>
            <div className={app.sectionHeading}>{LOADING}</div>
            <div>
                <CircularProgress />
            </div>
        </div>
    );
};

BusyIndicator.propTypes = {
    customClass: PropTypes.string
};

export default BusyIndicator;
